<template lang="pug">
div
    //- HERO/INTRO
    section(class="builds-hero bg-black w-full flex justify-center items-center")
    section(class="topography-bg bg-gray-darkest")
        div(class="lg:container")
            div(class="text-white grid grid-cols-1 md:grid-cols-2 md:gap-4 md:items-center")
                div(class="builds-hero hidden w-full md:block md:order-last md:h-96")

                div(class="px-4 py-6 space-y-8")
                    img(
                        alt="RealBuilds"
                        width="375"
                        height="65"
                        src="//realtruck.com/assets/8106f3d3-e677-43f3-bfac-1bafc1499118/static/realbuilds-logo.svg"
                    )

                    p Check out real builds from the RealTruck community, and share your own! See how people have upgraded their vehicles to make every adventure unforgettable. We're inspired by awesome trucks; we hope you are too.

                    BaseButton(
                        :to="{ name: 'builds-submit' }"
                        color="PRIMARY"
                        isDarkText
                    ) UPLOAD MY BUILD&nbsp;&nbsp;+

    //- FILTERS/TOOLBAR
    SearchWrapper(:searchContext="$search.builds")
        div(id="searchTop")
        BuildsToolbar

        section(class="p-8 bg-gray-lighter flex flex-col justify-center items-center" v-if="!hasResults")
            h4(class="text-gray-darker m-0 font-bold") NO FILTERED RESULTS FOUND
            h3(class="font-black text-gray mb-0") Showing All

        //- RENDER RESULTS CARDS
        section(class="lg:container px-4 pb-4")
            SearchResults(class="grid grid-cols-none gap-4 my-8 sm:grid-cols-2 lg:grid-cols-3")
                template(#result="{ result, index }")
                    BuildCard(:build="result" :isLazy="index > 5")

            SearchPagination(@click.native="scrollToTop")

    //- Search wrapper for when we do not have any results in the main index
    SearchWrapper(
        v-if="!hasResults"
        :searchContext="$search.buildsDefault"
    )
        //- RENDER RESULTS CARDS
        section(class="lg:container px-4")
            SearchResults(class="grid grid-cols-none gap-4 my-8 sm:grid-cols-2 lg:grid-cols-3")
                template(#result="{ result, index }")
                    BuildCard(:build="result" :isLazy="index > 5")
</template>

<script>
import BaseButton from '@/components/baseButton'
import SearchResults from '@/components/search/results'
import SearchWrapper from '@/components/search/wrapper'
import SearchNoResults from '@/components/search/noResults'
import SearchPagination from '@/components/search/pagination'
import BuildCard from './_components/card'
import BuildsToolbar from './_components/toolbar'

export default {
    name: 'BuildSearchPage',
    components: {
        BaseButton,
        SearchResults,
        SearchWrapper,
        SearchNoResults,
        SearchPagination,
        BuildCard,
        BuildsToolbar,
    },
    async beforeRouteUpdate(to, from, next) {
        await this.$search.builds.syncFromRoute(to).search()
        await this.$search.buildsDefault.search()

        next()
    },
    beforeRouteLeave(to, from, next) {
        this.savedQuery = Object.assign({}, from.query)
        next()
    },
    async asyncData({ $search, route, error }) {
        try {
            await $search.builds.syncFromRoute(route).search()
            await $search.buildsDefault.search()
        } catch (err) {
            error({ statusCode: 404, message: 'Invalid URL' })
        }
    },
    data() {
        return {
            savedQuery: {},
        }
    },
    head() {
        return this.$metaHelpers
            .generateMetas({ title: 'RealBuilds [TITLE_SUFFIX]' }, this.$route)
            .format()
    },
    computed: {
        hasResults() {
            return this.$search.builds.state.results.length > 0
        },
        results() {
            if (this.hasResults) return this.$search.builds

            return this.$search.buildsDefault
        },
    },
    activated() {
        // if we have a status then show it.
        // We also early out so we don't restore previous search query.
        // If we need to change this we can but its not required right now.
        if (this.$route.query.status) {
            this.displayMessage(this.$route.query.status)
            return
        }

        if (Object.keys(this.savedQuery).length > 0) {
            this.$push.replace(
                Object.assign({}, this.$route, {
                    query: this.savedQuery,
                })
            )
        }
    },
    methods: {
        scrollToTop() {
            this.$scrollTo('#searchTop', 1)
        },
        displayMessage(status) {
            const route = {
                name: this.$route.name,
                query: { ...this.$route.query },
            }

            delete route.query.status

            this.$router.replace(route).then(() => {
                let message = ''

                switch (status) {
                    case 'SUBMITTED':
                        message = 'Build Submitted! Check your email to verify your submission.'
                        break

                    case 'SUBMITTED-REVIEW':
                        message = 'Build Submitted for Review!'
                        break

                    case 'UPDATED':
                        message = 'Build Updated!'
                        break

                    case 'PENDING':
                        message = 'Build Updated! Check your email to verify your submission.'
                        break

                    case 'REVIEW':
                        message = 'Build Updated! Pending review.'
                        break

                    case 'DELETED':
                        message = 'Build Deleted!'
                        break
                }

                if (message)
                    this.$store.dispatch('addGeneralSuccess', {
                        message,
                    })
            })
        },
    },
}
</script>

<style lang="stylus" scoped>
.topography-bg
    background: url('@/assets/topography.jpg')

@screen md
    .builds-hero
        background: url('@/assets/builds-banner.jpg')
        background-size cover
        background-repeat no-repeat
        background-position center center
</style>
